export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Maj',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dec',
  ],
  months: [
    'Januari',
    'Februari',
    'Mars',
    'April',
    'Maj',
    'Juni',
    'Juli',
    'Augusti',
    'September',
    'Oktober',
    'November',
    'December',
  ],
  months_calendar: {
    January: 'Januari',
    February: 'Februari',
    March: 'Mars',
    April: 'April',
    May: 'Maj',
    June: 'Juni',
    July: 'Juli',
    August: 'Augusti',
    September: 'September',
    October: 'Oktober',
    November: 'November',
    December: 'December',
  },
  // weekdays
  weekdays: ['Sö', 'M', 'Ti', 'O', 'To', 'F', 'L'],
  weekdays_booking_container: {
    Sunday: 'Söndag',
    Monday: 'Måndag',
    Tuesday: 'Tisdag',
    Wednesday: 'Onsdag',
    Thursday: 'Torsdag',
    Friday: 'Fredag',
    Saturday: 'Lördag',
  },
  weekdays_calendar: {
    Sun: 'Sön',
    Mon: 'Mån',
    Tue: 'Tis',
    Wed: 'Ons',
    Thu: 'Tor',
    Fri: 'Fre',
    Sat: 'Lör',
  },
  // additional translations
  today: 'Idag',
  tomorrow: 'Imorgon',
};
